import { render } from "./PageCrumbHeader.vue?vue&type=template&id=31c0b9c0&scoped=true"
import script from "./PageCrumbHeader.vue?vue&type=script&lang=js"
export * from "./PageCrumbHeader.vue?vue&type=script&lang=js"

import "./PageCrumbHeader.vue?vue&type=style&index=0&id=31c0b9c0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31c0b9c0"

export default script